import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Coins, ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function CreditsCard() {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const navigate = useNavigate();

  const freeRemaining = Math.max(0, 2 - (userData?.freeGenerationsUsed ?? 0));
  const credits = userData?.credits ?? 0;

  return (
    <div className="px-4 py-3 bg-blue-50/50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800">
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center gap-2">
          <div className="h-6 w-6 rounded-full bg-blue-100 dark:bg-blue-900/50 flex items-center justify-center">
            <Coins className="h-3 w-3 text-blue-600 dark:text-blue-400" />
          </div>
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {t('credits.title', 'Créditos')}
          </span>
        </div>
        <span className="text-lg font-bold text-blue-600 dark:text-blue-400">
          {credits}
        </span>
      </div>
      {freeRemaining > 0 && (
        <p className="text-[10px] text-gray-500 dark:text-gray-400 mb-1">
          {freeRemaining} {freeRemaining === 1 ? 'geração gratuita restante' : 'gerações gratuitas restantes'}
        </p>
      )}
      <button
        onClick={() => navigate('/buy-credits')}
        className="w-full mt-1 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 flex items-center justify-center gap-1.5 py-2 rounded-lg transition-colors"
      >
        <ShoppingCart className="h-3 w-3" />
        Comprar créditos
      </button>
    </div>
  );
}
